import {Component} from '@angular/core';
import {HeaderComponent} from './header/header.component';

@Component({
  selector: 'em-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  imports: [HeaderComponent],
})
export class MainComponent {}
